import {GameChatPanel, PlayersPanel} from '@glark-newco/game-library';
import {Box, Group} from '@mantine/core';
import {useCallback, useState} from 'react';
import styles from './ChatAndPlayersListPanel.module.css';
import {ExpandingButton} from './ExpandingButton';
import {Flipper} from './Flipper';
import {SupplyChainAvatarProvider} from './SupplyChainAvatar';
import {isUserPressingActiveButton} from '../utils/ChatAndPlayerListPanelUtils';

export interface ExpandingButtonsStateProps {
    chat: boolean;
    players: boolean;
}

const flipperStyles = {
    height: '100%',
    width: '100%',
    background: 'no-repeat url("/images/playerChatBackground.png")',
    backgroundSize: 'cover',
    borderRadius: '1.5em',
    border: '0.2em solid white',
};

export function ChatAndPlayerListPanel() {

    const [expandingButtonsState, setExpandingButtonsState] = useState<ExpandingButtonsStateProps>({
        chat: true,
        players: false,
    });

    const toggleView = useCallback((buttonTitle: string) => {
        if ( !isUserPressingActiveButton(buttonTitle, expandingButtonsState) ) {
            setExpandingButtonsState((prevState) => ({
                chat: !prevState.chat,
                players: !prevState.players,
            }));
        }
    }, [expandingButtonsState]);

    return (
        <Box className={styles.chatAndPlayersListPanel}>
            <Group justify="space-between">
                <ExpandingButton
                    active={expandingButtonsState.chat}
                    onClick={() => toggleView('CHAT')}
                    icon='images/conversation.svg'
                    label='CHAT'
                    expandDirection='RIGHT'
                />
                <ExpandingButton
                    active={expandingButtonsState.players}
                    onClick={() => toggleView('PLAYERS')}
                    icon='images/group.svg'
                    label='PLAYERS'
                    expandDirection='LEFT'
                />
            </Group>
            <Flipper flipped={expandingButtonsState.players}>
                <GameChatPanel avatar={SupplyChainAvatarProvider} style={{...flipperStyles}} />
                <PlayersPanel avatar={SupplyChainAvatarProvider} style={{...flipperStyles}} />
            </Flipper>
        </Box>
    );
}
